import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { toast } from '../utils/toast';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post('/auth/forgot-password', { email });
      if (response.data && response.data.success) {
        setSent(true);
        toast.success(response.data.message || 'Письмо с инструкциями отправлено на ваш email');
      } else {
        toast.error(response.data.error || 'Ошибка при отправке письма');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      // Даже при ошибке показываем успех для безопасности (не раскрываем, существует ли пользователь)
      if (error.response?.status === 200 || error.response?.data?.success) {
        setSent(true);
        toast.success('Если пользователь с таким email существует, письмо будет отправлено.');
      } else {
        toast.error(error.response?.data?.error || 'Ошибка при отправке письма');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>SAVEL'EV CRM</h1>
          <h2>Восстановление пароля</h2>
        </div>
        {!sent ? (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="input"
                placeholder="Введите ваш email"
              />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Отправка...' : 'Отправить инструкции'}
            </button>
            <div className="auth-links">
              <Link to="/login">Вспомнили пароль? Войти</Link>
            </div>
          </form>
        ) : (
          <div className="verification-status success">
            <div className="success-icon">✅</div>
            <p>Письмо с инструкциями по восстановлению пароля отправлено на ваш email.</p>
            <p className="info-message">
              Пожалуйста, проверьте вашу почту и следуйте инструкциям в письме.
            </p>
            <div className="verification-actions">
              <Link to="/login" className="btn btn-primary">Войти</Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
